/* ============================================================================
   os-cart-rec.js — single "You may also like" card in the cart drawer.
   Added 2026-10-02 (Lauren). Replaces the theme's recommendations carousel
   (theme setting cart_show_recommendations is OFF on this theme) with ONE
   product card and a direct Add to Cart, no carousel, no quick view.

   WHICH PRODUCT: the first in-stock product from PRIORITY that the shopper does
   not already have. "Already have" is matched on the fish keyword in any cart
   line title, so a Sockeye subscription counts as having Sockeye. Adds the
   one-time 12-pack. Edit PRIORITY / COPY below to change the lineup.

   SAFE BY DEFAULT: any fetch failure renders nothing; the purchase path never
   depends on this script. Drawer only (.cart--draw), not the /cart page.
   ============================================================================ */
import Cart from 'cart-store';

(function () {
  'use strict';
  if (window.__osCartRec) { return; }
  window.__osCartRec = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PRIORITY = [
    { handle: 'wild-sockeye-salmon', key: 'sockeye' },
    { handle: 'alaskan-black-cod', key: 'black cod|sablefish' },
    { handle: 'alaskan-halibut', key: 'halibut' },
    { handle: 'wild-alaskan-coho-salmon-fillets', key: 'coho' },
    { handle: 'premium-fish-variety-box-assorted-filet', key: 'variety|gift box' }
  ];
  var COPY = {
    'wild-sockeye-salmon': 'Rich, bold and vibrant. Our everyday favorite.',
    'alaskan-black-cod': 'Buttery and delicate. Melts in your mouth.',
    'alaskan-halibut': 'Lean, mild and firm. The easy crowd-pleaser.',
    'wild-alaskan-coho-salmon-fillets': 'Mild and versatile. Weeknight-friendly salmon.',
    'premium-fish-variety-box-assorted-filet': 'Can’t decide? A little of everything we catch.'
  };

  /* The theme's cart store, imported statically. This file is an ES module
     (loaded with type="module"): Shopify's asset minifier rewrites a dynamic
     import() in a classic script into require(), which does not exist in the
     browser, so the store would silently never load. */
  function cartModule() { return Promise.resolve(Cart || null); }

  function money(c) { if (typeof c !== 'number') { return ''; } var s = (c / 100).toFixed(2); return '$' + (s.slice(-3) === '.00' ? s.slice(0, -3) : s); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function getJSON(u) { return fetch(ROOT.replace(/\/$/, '') + u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.json(); }); }

  var productCache = {};
  function product(handle) {
    if (!productCache[handle]) { productCache[handle] = getJSON('/products/' + handle + '.js').catch(function () { return null; }); }
    return productCache[handle];
  }

  function pick() {
    return getJSON('/cart.js').then(function (cart) {
      var items = (cart && cart.items) || [];
      if (!items.length) { return null; }
      var titles = items.map(function (i) { return String(i.product_title || '').toLowerCase(); }).join(' || ');
      var candidates = PRIORITY.filter(function (p) { return !new RegExp(p.key).test(titles); });
      var i = 0;
      function next() {
        if (i >= candidates.length) { return null; }
        var c = candidates[i++];
        return product(c.handle).then(function (p) {
          if (!p || p.available === false) { return next(); }
          var vs = (p.variants || []).filter(function (v) { return v.available !== false; });
          var v = vs.filter(function (v) { return /(^|\D)12(\D|$)/.test(v.title); })[0] || vs[0];
          if (!v) { return next(); }
          var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
          if (img && img.indexOf('//') === 0) { img = 'https:' + img; }
          return { handle: c.handle, title: p.title, url: p.url || ('/products/' + c.handle), variant: v.id,
            price: v.price, compare: v.compare_at_price, img: img, copy: COPY[c.handle] || '' };
        });
      }
      return next();
    }).catch(function () { return null; });
  }

  function html(r) {
    var was = r.compare && r.compare > r.price ? ' <s class="os-rec__was">' + money(r.compare) + '</s>' : '';
    var src = r.img ? r.img + (r.img.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
    return '<p class="os-rec__head">You may also like</p>' +
      '<div class="os-rec__card">' +
        '<a class="os-rec__img" href="' + esc(r.url) + '" tabindex="-1" aria-hidden="true">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
        '<div class="os-rec__body">' +
          '<a class="os-rec__title" href="' + esc(r.url) + '">' + esc(r.title) + '</a>' +
          '<div class="os-rec__price">' + money(r.price) + was + ' <span class="os-rec__pack">12 pack</span></div>' +
          (r.copy ? '<p class="os-rec__copy">' + esc(r.copy) + '</p>' : '') +
          '<button type="button" class="os-rec__btn" data-os-rec-add="' + esc(r.variant) + '">Add to Cart</button>' +
        '</div>' +
      '</div>';
  }

  var current = null;
  function paint() {
    var hosts = document.querySelectorAll('.cart--draw cart-contents');
    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h];
      var box = host.querySelector(':scope > [data-os="cart-rec"]');
      if (!current) { if (box) { box.remove(); } continue; }
      var sig = current.handle + ':' + current.variant;
      if (box && box.getAttribute('data-os-sig') === sig) { continue; }
      if (!box) {
        box = document.createElement('div');
        box.className = 'os-rec';
        box.setAttribute('data-os', 'cart-rec');
        var items = host.querySelector('cart-items');
        if (items) { items.insertAdjacentElement('afterend', box); } else { host.appendChild(box); }
      }
      box.setAttribute('data-os-sig', sig);
      box.innerHTML = html(current);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-os-rec-add]') : null;
    if (!btn || btn.hasAttribute('data-busy')) { return; }
    e.preventDefault();
    var id = btn.getAttribute('data-os-rec-add');
    btn.setAttribute('data-busy', ''); btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…';
    cartModule().then(function (C) {
      if (C && typeof C.add === 'function') { return C.add({ id: Number(id), quantity: 1 }); }
      return fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) { throw new Error('add failed'); } });
    }).then(function () {
      return cartModule().then(function (C) {
        if (C && typeof C.refresh === 'function') { try { C.refresh(); } catch (e) {} }
        ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) { try { document.dispatchEvent(new Event(ev)); } catch (e) {} });
      });
    }).then(function () { refresh(); }).catch(function () {
      btn.removeAttribute('data-busy'); btn.removeAttribute('aria-busy'); btn.textContent = 'Try again';
    });
  });

  var token = 0;
  function refresh() {
    var mine = ++token;
    pick().then(function (r) { if (mine !== token) { return; } current = r; try { paint(); } catch (e) {} });
  }
  var queued = false;
  function schedule() {
    if (queued) { return; } queued = true;
    setTimeout(function () { queued = false; try { paint(); } catch (e) {} }, 60);
  }
  function boot() {
    refresh();
    try { new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
    ['cart:updated', 'cart:refresh', 'cart:open', 'cart:change', 'cart:added', 'on:cart:loaded'].forEach(function (ev) {
      document.addEventListener(ev, function () { refresh(); });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
